module.exports = __webpack_public_path__ + "img/mark_star_9_icon.02da1dc7.png";